import * as Yup from 'yup';

export const rejectionReasonsSchema = Yup.object().shape({
  name: Yup.string().required(),
});
